export class FilterTags{
  constructor(
    public tagId: any = '',
    public location: any = '',
    public unit: any = '',
    public equipment: any = '',
    public useCase: any = ''
  ) { } 
}

